import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.scss';


//pages or components importing area
import Home from './pages/Home'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className='Pages'>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
